module.exports = __webpack_public_path__ + "static/img/kjdy4.41456a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/kjdy4.png
// module id = 339
// module chunks = 0